/* Bluorng card dots -------------------------------------------------------
   The source shows a row of white dots on every product card, one per
   image, tracking the card's own image carousel. Horizon runs that
   carousel (product_card_carousel) but renders no dots for it, so this
   draws them and keeps the active one in step with the scroller.
   Defensive: no markup, nothing happens.
-------------------------------------------------------------------------- */
(function () {
  'use strict';

  function build(card) {
    var comp = card.querySelector('.card-gallery slideshow-component');
    if (!comp || comp.querySelector('.blu-dots')) return;
    var slides = comp.querySelectorAll('slideshow-slide');
    if (slides.length < 2) return;
    var scroller = comp.querySelector('slideshow-slides');

    var dots = document.createElement('div');
    dots.className = 'blu-dots';
    dots.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < slides.length; i++) {
      var d = document.createElement('span');
      d.className = 'blu-dots__dot' + (i === 0 ? ' is-active' : '');
      dots.appendChild(d);
    }
    comp.appendChild(dots);

    function update() {
      if (!scroller) return;
      var w = scroller.clientWidth || 1;
      var idx = Math.round(scroller.scrollLeft / w);
      var ds = dots.children;
      for (var j = 0; j < ds.length; j++) ds[j].classList.toggle('is-active', j === idx);
    }
    if (scroller) scroller.addEventListener('scroll', update, { passive: true });
    comp.addEventListener('slideChanged', update);
  }

  var pending = null;
  function init() {
    try {
      document.querySelectorAll('.product-card').forEach(build);
    } catch (e) { /* presentation only */ }
  }
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; init(); }, 120);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', schedule);
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
})();

/* Collection: "Advance Filters" ------------------------------------------
   The source's title row carries a grid toggle and one filter pill that
   opens a drawer. Horizon has that drawer already — it is the mobile
   filter dialog, and it opens fine on desktop — plus a hidden toggle button
   wired to it. This adds the pill and routes it to that toggle.
-------------------------------------------------------------------------- */
(function () {
  'use strict';

  function init() {
    try {
      var main = document.querySelector('main[data-template="collection"]');
      if (!main) return;
      var bar = main.querySelector('.facets--horizontal');
      if (!bar || bar.querySelector('.blu-filters')) return;
      var toggle = main.querySelector('.facets-toggle__button');
      var dlg = main.querySelector('dialog-component dialog');
      if (!toggle && !dlg) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'blu-filters';
      btn.textContent = 'Advance Filters';
      btn.addEventListener('click', function () {
        if (toggle) { toggle.click(); return; }
        if (dlg && typeof dlg.showModal === 'function' && !dlg.open) dlg.showModal();
      });
      bar.appendChild(btn);
    } catch (e) { /* presentation only */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();


/* Collection chips carry a product count Horizon prints inside the link
   text ("T-Shirts 70"); the source's chips are the name alone. Any element
   or text node inside a chip that is only digits is removed.            */
(function () {
  'use strict';
  function strip() {
    try {
      document.querySelectorAll('.collection-links__link').forEach(function (a) {
        a.querySelectorAll('*').forEach(function (e) {
          if (/^\s*\d+\s*$/.test(e.textContent || '')) e.remove();
        });
        Array.prototype.slice.call(a.childNodes).forEach(function (n) {
          if (n.nodeType === 3 && /^\s*\d+\s*$/.test(n.textContent || '')) n.remove();
        });
        a.querySelectorAll('*').forEach(function (e) {
          if (e.children.length === 0 && /\s\d+\s*$/.test(e.textContent || '')) {
            e.textContent = e.textContent.replace(/\s\d+\s*$/, '');
          }
        });
      });
    } catch (e) { /* presentation only */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', strip);
  else strip();
  document.addEventListener('shopify:section:load', strip);
})();


/* The source's collection chips start with "View all" and leave out the
   collection being viewed. Prepend the one, hide the other.             */
(function () {
  'use strict';
  function chips() {
    try {
      var container = document.querySelector('main[data-template="collection"] .collection-links__container');
      if (!container || container.querySelector('.blu-chip-all')) return;
      var path = location.pathname.replace(/\/+$/, '');
      var links = container.querySelectorAll('a.collection-links__link');
      var current = null;
      links.forEach(function (a) {
        var href = (a.getAttribute('href') || '').split('?')[0].replace(/\/+$/, '');
        if (href === path) current = a;
      });
      if (current) {
        var item = current.closest('.collection-links__container > *') || current;
        item.classList.add('blu-chip-current');
      }
      var all = document.createElement('a');
      all.className = 'collection-links__link blu-chip-all';
      all.href = '/collections/all';
      all.textContent = 'View all';
      if (path === '/collections/all') all.classList.add('blu-chip-current');
      container.insertBefore(all, container.firstChild);
    } catch (e) { /* presentation only */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', chips);
  else chips();
  document.addEventListener('shopify:section:load', chips);
})();


/* Desktop menu: the burger's <details> drives the full-width panel that the
   source slides in under its header. Horizon's own drawer is hidden there. */
(function () {
  'use strict';
  var mq = window.matchMedia('(min-width: 750px)');
  function init() {
    var details = document.getElementById('Details-menu-drawer-container');
    var panel = document.getElementById('blu-mega');
    if (!details || !panel || panel.dataset.wired) return;
    panel.dataset.wired = '1';
    var summary = details.querySelector('summary');
    var sync = function () {
      var open = details.open;
      panel.classList.toggle('is-open', open);
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
      // The desktop panel leaves the page scrollable (no scrollbar jump);
      // the phone sheet keeps Horizon's scroll lock.
      if (mq.matches) details.removeAttribute('scroll-lock');
      else details.setAttribute('scroll-lock', '');
    };
    details.addEventListener('toggle', sync);
    // The pill toggles the <details> directly. Horizon's own toggle waits for
    // its (hidden) drawer's animation, which now resolves before the
    // summary's native toggle runs and leaves the menu stuck open.
    if (summary) {
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var wasOpen = panel.classList.contains('is-open');
        details.open = !wasOpen;
      }, true);
    }
    // Desktop with a real pointer: hovering the pill opens the panel; it
    // closes once the pointer has left the pill, the bar and the panel.
    var hoverMq = window.matchMedia('(min-width: 750px) and (hover: hover)');
    var headerRow = document.querySelector('.header__row--top');
    var frame = panel.querySelector('.blu-mega__frame') || panel;
    var closeTimer = null, lastX = 0, lastY = 0;
    var inside = function (x, y) {
      return [summary, headerRow, frame].some(function (el) {
        if (!el) return false;
        var r = el.getBoundingClientRect();
        return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
      });
    };
    if (summary) {
      summary.addEventListener('mouseenter', function () {
        if (!hoverMq.matches) return;
        clearTimeout(closeTimer); closeTimer = null;
        if (!details.open) details.open = true;
      });
    }
    document.addEventListener('mousemove', function (e) {
      if (!hoverMq.matches || !details.open) return;
      lastX = e.clientX; lastY = e.clientY;
      if (inside(lastX, lastY)) { clearTimeout(closeTimer); closeTimer = null; return; }
      if (closeTimer) return;
      closeTimer = setTimeout(function () {
        closeTimer = null;
        if (details.open && !inside(lastX, lastY)) details.open = false;
      }, 250);
    });
    mq.addEventListener('change', sync);
    panel.querySelectorAll('[data-blu-mega-close], a').forEach(function (el) {
      el.addEventListener('click', function () { if (details.open) details.open = false; });
    });
    // Phones: the groups are accordions; desktop shows every chip.
    panel.querySelectorAll('.blu-mega__title').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (mq.matches) return;
        var group = btn.parentElement;
        var open = !group.classList.contains('is-open');
        group.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && details.open) details.open = false;
    });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* blu-search overlay patch: open the search modal non-modally so the header
   stays above it (the source drops the panel under the bar and dims the page
   below), name the footer action after the query, and let the phone bar's
   search item open it. */
(function () {
  var sm = document.getElementById('search-modal');
  if (!sm) return;
  var dialog = sm.querySelector('dialog');
  if (dialog) {
    dialog.showModal = function () {
      HTMLDialogElement.prototype.show.call(this);
    };
  }
  var input = sm.querySelector('input.search-input');
  var btn = sm.querySelector('.predictive-search__search-button');
  function label() {
    if (!input || !btn) return;
    var q = input.value.trim();
    btn.textContent = q ? 'Search for \u201C' + q + '\u201D' : 'Search';
  }
  if (input) {
    input.addEventListener('input', label);
    label();
  }
  document.querySelectorAll('.blu-mobile-nav a').forEach(function (a) {
    if (!/\/search\/?$/.test(a.getAttribute('href') || '')) return;
    a.addEventListener('click', function (e) {
      if (typeof sm.showDialog !== 'function') return;
      e.preventDefault();
      sm.showDialog();
    });
  });
})();

/* Product cards: the theme's own prev/next arrows are rendered on every
   card (card-gallery.liquid); this makes every image reachable and keeps
   the arrows working inside the home-page rails. */
(function () {
  'use strict';
  function wire(card) {
    var comp = card.querySelector('.card-gallery slideshow-component');
    if (!comp || comp.hasAttribute('data-blu-wired')) return;
    if (comp.querySelectorAll('slideshow-slide').length < 2) return;
    comp.setAttribute('data-blu-wired', '');
    // Horizon keeps every variant image but the first [hidden] and its
    // select() drops any reveal, so the slideshow initialises with one
    // slide. Unhide them and re-connect the component so it sets up
    // scrolling for all of them.
    var hidden = comp.querySelectorAll('slideshow-slide[hidden]');
    if (hidden.length) {
      hidden.forEach(function (slide) {
        slide.removeAttribute('hidden');
        slide.setAttribute('aria-hidden', 'true');
      });
      var parent = comp.parentNode, after = comp.nextSibling;
      parent.removeChild(comp);
      parent.insertBefore(comp, after);
    }
    // A card gallery nested in a rail carousel is disabled by Horizon so
    // touch swipes go to the rail. Pointers do not swipe, so enable it on
    // desktop (arrows + hover preview) and keep it off on the phone.
    if (comp.parentElement && comp.parentElement.closest('slideshow-component')) {
      comp.setAttribute('disabled', 'false');
      comp.setAttribute('mobile-disabled', '');
    }
  }
  function init() { document.querySelectorAll('.product-card').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(function () { init(); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Sticky header: slides away while scrolling down, comes back as soon as
   the page scrolls up (never while a panel is open). */
(function () {
  'use strict';
  var section = document.querySelector('.header-section');
  var header = document.querySelector('header-component');
  if (!section || !header) return;
  var lastY = window.scrollY, ticking = false, trail = null;
  function panelOpen() {
    var d = document.getElementById('Details-menu-drawer-container');
    var s = document.querySelector('#search-modal dialog');
    return (d && d.open) || (s && s.open);
  }
  function update() {
    ticking = false;
    var y = window.scrollY;
    var h = header.offsetHeight || 60;
    if (y <= h || panelOpen() || y < lastY - 2) {
      section.classList.remove('blu-header-hidden');
    } else if (y > lastY + 2) {
      section.classList.add('blu-header-hidden');
    }
    lastY = y;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; setTimeout(update, 16); }
    clearTimeout(trail);
    trail = setTimeout(update, 160);
  }, { passive: true });
})();
